<li class="list-item">
  <ng-content></ng-content>
</li>
